// pattern: imperative-shell

export type Route = "timeline" | "new" | "edit" | "search" | "locations";

export interface ParsedRoute {
	route: Route;
	params: Record<string, string>;
}

export function parseHash(hash: string): ParsedRoute {
	const path = hash.replace(/^#\/?/, "") || "";

	if (path === "" || path === "/") {
		return { route: "timeline", params: {} };
	}
	if (path === "new") {
		return { route: "new", params: {} };
	}
	if (path.startsWith("edit/")) {
		return { route: "edit", params: { id: path.slice(5) } };
	}
	if (path === "search") {
		return { route: "search", params: {} };
	}
	if (path === "locations") {
		return { route: "locations", params: {} };
	}

	return { route: "timeline", params: {} };
}

export function navigate(route: string): void {
	window.location.hash = `#/${route}`;
}

export function onRouteChange(callback: (parsed: ParsedRoute) => void): void {
	const handler = () => callback(parseHash(window.location.hash));
	window.addEventListener("hashchange", handler);
	// Fire immediately for initial route
	handler();
}
